'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _exenv = require('exenv');

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

exports.default = SafeHTMLElement;


//////////////////
// WEBPACK FOOTER
// ./~/react-modal/lib/helpers/safeHTMLElement.js
// module id = 179
// module chunks = 0